<template>
    <div class="card">
        <div class="card-header">
            <h3 class="card-title">{{ lang.setup_language }}</h3>
        </div>
        <div class="card-body">
            <form @submit.prevent="save">
                <div class="form-row"  style="margin-bottom: 20px;">
                    <span>{{ lang.setup_language }}</span>
                    <select class="form-control" v-model="langUpdate">
                        <option value="en">English</option>
                        <option value="es">Spanish</option>
                    </select>
                    <small style="margin-left: 10px; "> {{ lang.setup_general_setting }} </small>
                </div>
                <div class="form-actions">
                    <button class="btn btn-primary btn-lg" type="submit">{{ lang.bs_save }}</button>
                    <button type="button" class="btn  btn-lg" @click="$modal.hide('modal-setting')">{{ lang.bs_cancel }}</button>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    name: 'changeLangApp',
    data() {
        return {
            lang: {},
            langUpdate: 'en',
        };
    },
    created() {
        this.lang = this.$store.getters['ModApps/Marketea/lang'];
        this.langUpdate = this.$store.getters['ModApps/Marketea/get_langUpdate'];
        this.pullLang();
    },
    methods: {
        pullLang() {
            let urlService = 'bSite/pullLang'// setInfo
            let dataSend = {
                user_id: window.master_client,
                org_id: window.localorgdata,
            }
            window.master.post(urlService, dataSend)
            .then((response) => {
                console.log(urlService, response.data);
                if(response.data.lang && this.langUpdate != response.data.lang){
                    this.langUpdate = response.data.lang;
                    this.$store.commit('ModApps/Marketea/set_langApp', response.data.lang);
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        save() {
            let urlService = 'bSite/pullLang'// setInfo
            let dataSend = {
                user_id: window.master_client,
                org_id: window.localorgdata,
                lang: this.langUpdate,
            }
            window.master.post(urlService, dataSend)
            .then((response) => {
                console.log(urlService, response.data);
                this.$store.commit('ModApps/Marketea/set_langApp', response.data.lang);
                // reload para actualizar los textos en el idioma seleccionado
                // window.location.reload();
                this.$modal.hide('modal-setting');
            })
            .catch((error) => {
                console.log(error);
            });
        },
    },
    computed: {
        ...mapGetters("ModApps/Marketea", {
            langGetter: "lang",
            get_langUpdate: "get_langUpdate",
        }),
    },
    watch: {
        get_langUpdate(newLang) {
            this.langUpdate = newLang;
        },
        langGetter() {
            this.lang = this.$store.getters['ModApps/Marketea/lang'];
        },
    }
}
</script>